import React, {Component} from 'react'
import Radium from 'radium'
import Link from "gatsby-link";
import SingleFormLayout from '../components/single-form-layout'
import Navbar from '../components/navbar'
import MobileContent from '../components/mobile-content'
import {FORM_STYLES} from '../components/assets/forms-shared'
import Palette from '../components/assets/palette'
import Color from 'color'
import Helmet from 'react-helmet'
import { HaikuMiniIconSVG, FacebookSVG, TwitterSVG, SlackSVG, HaikuIconGradioSVG } from '../components/assets/icons'
import MobileDetect from 'mobile-detect'

const windowWidth = (typeof window !== 'undefined') && window.innerWidth
const md = (typeof window !== 'undefined')
  ? new MobileDetect(window.navigator.userAgent)
  : {mobile: () => { return false }}
const isMobile = md.mobile()

import '../../src/layouts/main.css'

const STYLES = {
  blogHeaderWrap: {
    backgroundColor: Palette.COAL,
    position: 'relative',
    paddingTop: 90,
    paddingBottom: 30,
    color: Palette.SUNSTONE,
    textAlign: 'center',
    '@media screen and (max-width: 1115px)': {
      marginTop: 0
    },
  },
  blogWrap: {
    marginTop: 0,
    width: '100%',
    color: Palette.LIGHTEST_GRAY,
    minHeight: 200,
    display: 'inline-block',
    padding: '60px 10px 100px',
  },
  blogContentWrap:{
    margin: '0 auto',
    backgroundColor: 'rgb(252,252,252)',
    borderRadius: 12,
    width: '98%',
    maxWidth: 980,
    minWidth: 300,
    padding: '20px 46px 20px',
    minHeight: 'calc(100vh - 260px)',
    boxShadow: '0 20px 150px 0 rgba(0,0,0,.5)',
  },
  keepReadingWrap:{
    margin: '0 auto',
    width: '98%',
    maxWidth: 980,
    minWidth: 300,
  },
  link: {
    color: Palette.LIGHT_BLUE,
    textDecoration: 'none'
  },
  title: {
    color: Palette.SUNSTONE
  },
  authorWrap: {
    textAlign: 'center',
    display: 'block',
    textDecoration: 'none',
    marginTop: -40,
    fontSize: 16,
  },
  authorHeadshot: {
    backgroundColor: 'lightgrey',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    borderRadius: 40,
    height: 60,
    left: 'calc(50% - 30px)',
    top: -50,
    position: 'relative',
    width: 60,
    margin: '0 auto'
  },
  authorName: {
    fontWeight: 'bold',
    marginTop: 7,
    marginBottom: 0,
    color: Palette.LIGHTEST_GRAY,
    fontSize: 16
  },
  authorBlurb: {
    marginTop: -2,
    marginBottom: 0,
    color: Color(Palette.DARKER_ROCK).darken(.2),
    fontSize: 16
  },
  twitterContainer: {
    position: 'relative'
  },
  twitterLogo: {
    cursor: 'pointer',
    top: -1,
    position: 'absolute'
  },
  blogPost: {
    fontSize: 21 //TODO: mobile = 18
  },
  keepReadingContent: {
    padding: 12
  },
  keepReadingTitle: {
    color: Palette.LIGHT_BLUE,
    textTransform: 'uppercase',
    fontSize: 22,
    marginTop: 5,
    marginBottom: 5,
  },
  keepReadingSubtitle: {
    color: Palette.SUNSTONE,
    marginTop: 80,
  },
  keepReadingAuthorWrap: {
    display: 'block',
    textDecoration: 'none',
    position: 'relative',
    minHeight: 50
  },
  keepReadingAuthorHeadshot: {
    backgroundColor: 'lightgrey',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    borderRadius: 20,
    position: 'absolute',
    height: 40,
    left: 0,
    bottom: 0,
    width: 40
  },
  keepReadingAuthorName: {
    position: 'absolute',
    bottom: 8,
    left: 50,
    marginBottom: 0,
    color: Palette.SUNSTONE,
    fontSize: 16
  },
  tag: {
    fontSize: 14,
    background: Palette.LIGHTEST_PINK,
    color: Palette.SUNSTONE,
    borderRadius: 4,
    padding: 5,
    marginTop: 15,
    display: 'inline-block'
  },
  ...FORM_STYLES
}

export default class Template extends Component {
  componentDidMount() {
    setTimeout(() => {
      window.scrollTo(0,0)
    })
  }

  render () {
    const { data, pathContext } = this.props;
    const { markdownRemark: post } = data; // data.markdownRemark holds our post data
    const { next, prev } = pathContext;

    return (
      <div>

        <Helmet>
          <title>{`Haiku Blog - ${post.frontmatter.title}`}</title>
          {post.excerpt && <meta name="description" content={post.excerpt} />}
          {post.frontmatter.canonicalUrl && <link rel="canonical" href={post.frontmatter.canonicalUrl} />}
          {post.frontmatter.title && <meta property="og:title" content={post.frontmatter.title} />}
          {post.excerpt && <meta property="og:description" content={post.excerpt} />}
          {post.frontmatter.coverImage.publicURL && <meta property="og:image" content={`${process.env.SITE_URL}${post.frontmatter.coverImage}`} />}
          {post.frontmatter.path && <meta property="og:url" content={`${process.env.SITE_URL}${post.frontmatter.path}`} />}
        </Helmet>

        <Navbar location="blog" />

        <div style={{
          margin: '0 auto',
          width: '100%'
        }}>

          <div style={STYLES.blogHeaderWrap}>
            <Link style={STYLES.title} to="/blog/">
              <HaikuIconGradioSVG width={80} height={80} />
              <h2 style={{marginTop: 20}}>Haiku Blog</h2>
            </Link>
          </div>

          <div style={STYLES.blogWrap}>
            <div style={STYLES.blogContentWrap}>
              <div className="blog-post-container">
                <img src={post.frontmatter.authorHeadshot} style={STYLES.authorHeadshot} alt={post.frontmatter.authorName}/>
                <div style={STYLES.authorWrap}>
                  <div style={STYLES.authorName}>
                    {post.frontmatter.authorName}
                    { post.frontmatter.twitterLink && <a target="_blank" href={post.frontmatter.twitterLink} style={STYLES.twitterContainer}><span style={STYLES.twitterLogo}><TwitterSVG color="rgb(72,160,236)" /></span></a> }
                  </div>
                  <div style={STYLES.authorBlurb}>{post.frontmatter.authorBlurb}</div>
                </div>
                <div className="blog-post" style={STYLES.blogPost}>
                  <div style={{textAlign:'center', marginTop: 0}}>
                    <h1>{post.frontmatter.title}</h1>
                    <div style={STYLES.authorBlurb}>
                      {post.frontmatter.date}
                      {post.frontmatter.readLength && <span> - {post.frontmatter.readLength} min read</span>}
                    </div>
                    {post.frontmatter.tags && post.frontmatter.tags.map((tag) => <span style={STYLES.tag}>{tag}</span>)}
                  </div>

                    <div
                      className="blog-post-content"
                      dangerouslySetInnerHTML={{ __html: post.html }}
                    >
                    </div>

                </div>


              </div>
            </div>

            <div style={STYLES.keepReadingWrap}>
            <div className="keep-reading">
              {next &&
                <div>
                  <h5 style={STYLES.keepReadingSubtitle}>Previous Post</h5>
                  <Link className="link next" to={next.path}>
                    <div className="keep-reading-block" style={STYLES.keepReading}>
                      <img className="blogFeatureImage" src={next.coverImage.publicURL} alt={next.title}/>
                      <div style={STYLES.keepReadingContent}>
                        <p style={STYLES.keepReadingTitle}>{next.title}</p>
                        <div style={STYLES.keepReadingAuthorWrap}>
                          <img src={next.authorHeadshot} style={STYLES.keepReadingAuthorHeadshot} alt={next.authorName}/>
                          <p style={STYLES.keepReadingAuthorName}>{next.authorName}</p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>}
                {prev &&
                  <div>
                    <h5 style={STYLES.keepReadingSubtitle}>Next Post</h5>
                    <Link className="link prev" to={prev.path}>
                        <div className="keep-reading-block" style={STYLES.keepReading}>
                          <img className="blogFeatureImage" src={prev.coverImage.publicURL} alt={prev.title}/>
                          <div style={STYLES.keepReadingContent}>
                            <p style={STYLES.keepReadingTitle}>{prev.title}</p>
                            <div style={STYLES.keepReadingAuthorWrap}>
                              <img src={prev.authorHeadshot} style={STYLES.keepReadingAuthorHeadshot} alt={prev.authorName}/>
                              <p style={STYLES.keepReadingAuthorName}>{prev.authorName}</p>
                            </div>
                          </div>
                        </div>
                    </Link>
                  </div>}
              </div>
            </div>

          </div>

        </div>

          <MobileContent />

      </div>
    );
  }
  }

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      excerpt
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
        authorHeadshot
        authorName
        authorBlurb
        twitterLink
        canonicalUrl
        coverImage {
          publicURL
        }
        readLength
        tags
      }
    }
  }
`
;



// WEBPACK FOOTER //
// ./src/templates/blog-post.js